import type { Theme } from '../../types/theme';

export const cloudflareTheme: Theme = {
  id: 'cloudflare',
  name: 'Cloudflare',
  description: 'Orange and dark technical aesthetic for edge computing platform',
  sourceDesignMd: 'https://github.com/VoltAgent/awesome-design-md/blob/main/design-md/cloudflare/DESIGN.md',
  visualKeywords: ['orange accent', 'dark', 'edge computing', 'CDN', 'security'],
  colors: {
    background: '#0a0a0a',
    surface: '#141414',
    surfaceElevated: '#1e1e1e',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0a0',
    textMuted: '#a0a0a0',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#f6821f',
    primaryHover: '#ff9035',
    primaryActive: '#d66b0d',
    accent: '#f6821f',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
